import { render } from "./ViewBuzz.vue?vue&type=template&id=41ac401c&scoped=true"
import script from "./ViewBuzz.vue?vue&type=script&lang=js"
export * from "./ViewBuzz.vue?vue&type=script&lang=js"

import "./view-buzz.scss?vue&type=style&index=0&id=41ac401c&lang=scss&scoped=true"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ac401c"]])

export default __exports__